import { BlocksViewNode } from '../types';

export const getColIndex = (gridNode: BlocksViewNode, pos: number) => {
  let colPos = gridNode.content![0]; // TODO initialise from content rect

  if (colPos > pos) {
    return -1;
  }

  // this can never return less than
  for (let ret = 0; ret < gridNode.colSize!.length; ++ret) {
    colPos += gridNode.colSize![ret];

    if (colPos > pos) {
      return ret;
    }
  }

  return gridNode.colSize!.length;
};

export const getRowIndex = (gridNode: BlocksViewNode, pos: number) => {
  let rowPos = gridNode.content![1]; // TODO initialise from content rect

  if (rowPos > pos) {
    return -1;
  }

  for (let ret = 0; ret < gridNode.rowSize!.length; ++ret) {
    rowPos += gridNode.rowSize![ret];

    if (rowPos > pos) {
      return ret;
    }
  }

  return gridNode.rowSize!.length;
};
